export default function getNonce() {
    return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
}
//# sourceMappingURL=nonce.js.map